import { createOffline } from '@redux-offline/redux-offline';
import { configureStore } from '@reduxjs/toolkit';
import gccApiClient from 'gcs-common/clients/gccApiClient/gccApiClient';
import videoClient from 'gcs-common/clients/videoClient/videoClient';
import { sentryReduxEnhancer } from 'gcs-common/config/sentryReduxEnhancer';
import customStoreSerializableCheck from 'gcs-common/constants/customStoreSerializableCheck';
import googleAnalyticsMiddleware from 'gcs-common/middlewares/googleAnalyticsMiddleware';
import onExceptionMiddleware from 'gcs-common/middlewares/onExceptionMiddleware';
import openErrorDialogMiddleware from 'gcs-common/middlewares/openErrorDialogMiddleware';
import offlineConfig from './offlineConfig';
import createRootReducer from './rootReducer';

// this is to avoid a circular dependency
let store = null;
const getStore = () => store;

const { middleware: offlineMiddleware, enhanceReducer, enhanceStore } = createOffline(offlineConfig({ getStore }));

// Note: For middleware order is important!
const createStore = ({ preloadedState } = {}) =>
  configureStore({
    reducer: enhanceReducer(createRootReducer()),
    middleware: (getDefaultMiddleware) => [
      onExceptionMiddleware,
      ...getDefaultMiddleware({
        thunk: {
          extraArgument: {
            gccApiClient,
            videoClient,
          },
        },
        // not necessary since we are using immer which detects mutations in dev mode out of the box
        // https://github.com/reduxjs/redux-toolkit/issues/805
        immutableCheck: false,
        serializableCheck: { isSerializable: customStoreSerializableCheck },
      }),
      offlineMiddleware,
      googleAnalyticsMiddleware,
      openErrorDialogMiddleware,
    ],
    enhancers: [sentryReduxEnhancer, enhanceStore],
    preloadedState,
  });

store = createStore();

export { createStore };

export default store;
